/* @flow */
import UsersSmsInviteInstructions from './UsersSmsInviteInstructions';

export default UsersSmsInviteInstructions;
